<template>
	<div class="notice_popup">
		<div class="close" @click="$emit('close')">
			<img src="/images/close.png" alt="닫기">
		</div>
		<div class="tit">블로그 {{statusMsg[status]}}</div>
		<div class="member">
			<span v-if="list.length > 0">‘{{list[0].blogTitle}}’<br>
			<template v-if="list.length > 1">외 {{list.length - 1}}개</template></span> 블로그를 {{statusMsg[status]}}하시겠습니까?
		</div>
		<div class="select-btn">
			<div class="btn" @click="$emit('close')">취소</div>
			<div class="btn" @click="send()">예</div> 
		</div>
	</div>
</template>
<script>

export default {
	props: { param:Object },
	data() {
		return {
			list: this.param.list,
			status:this.param.status,
			statusMsg:{'off':'노출종료', 'del':'삭제'}
		};
	},
	beforeMount(){
		if(!Array.isArray(this.param.list) || this.param.list.length == 0){
			alert('블로그정보를 확인 할 수 없습니다.');
			this.$emit('close');
			return;
		}
	},
	methods: {
		send(){
			this.$.httpPost('/api/main/bnr/setblogStatusYn', {list : this.list, status: this.status})
				.then(() => {
					alert('블로그 ' + this.statusMsg[this.status] +'를 완료하였습니다.');
					this.$emit('close', true);
				}).catch(this.$.httpErrorCommon);
		}
	},
};
</script>
